import React, { useState } from 'react';

const REGEX_MAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const REGEX_SIRET = /^\d{14}$/;

/**
 * Champ de saisie texte réutilisable
 * @param {string} label - Label affiché au-dessus du champ
 * @param {string} valeur - Valeur actuelle
 * @param {function} onChange - Callback de changement
 * @param {string} placeholder - Texte indicatif
 * @param {string} infobulle - Aide contextuelle sous le champ
 * @param {boolean} pleineLargeur - Si true, occupe toute la largeur de la grille
 * @param {boolean} typeMail - Si true, valide le format e-mail (ex. test@truc.truc)
 * @param {boolean} typeSiret - Si true, valide le format SIRET (14 chiffres)
 */
function ChampTexte({ label, valeur, onChange, placeholder, infobulle, pleineLargeur, nom, maxLength, chiffresUniquement, typeMail, typeSiret }) {
  const [touched, setTouched] = useState(false);
  const mailInvalide = typeMail && valeur && !REGEX_MAIL.test(valeur);
  const siretInvalide = typeSiret && valeur && !REGEX_SIRET.test(valeur);
  const afficherErreurMail = typeMail && touched && mailInvalide;
  const afficherErreurSiret = typeSiret && touched && siretInvalide;

  const gererChangement = (e) => {
    let val = e.target.value;
    if (chiffresUniquement) val = val.replace(/\D/g, '');
    if (maxLength) val = val.slice(0, maxLength);
    onChange(nom || label, val);
  };

  return (
    <div className={`champ${pleineLargeur ? ' champ--pleine-largeur' : ''}`}>
      {label && <label className="champ__label">{label}</label>}
      <input
        type={typeMail ? 'email' : 'text'}
        className={`champ__input${afficherErreurMail || afficherErreurSiret ? ' champ__input--invalide' : ''}`}
        value={valeur}
        onChange={gererChangement}
        onBlur={() => (typeMail || typeSiret) && setTouched(true)}
        placeholder={placeholder || ''}
        maxLength={maxLength}
        inputMode={chiffresUniquement ? 'numeric' : undefined}
      />
      {afficherErreurMail && (
        <span className="champ__erreur">Format attendu : test@truc.truc</span>
      )}
      {afficherErreurSiret && (
        <span className="champ__erreur">Format attendu : 14 chiffres</span>
      )}
      {infobulle && <span className="champ__infobulle">{infobulle}</span>}
    </div>
  );
}

export default ChampTexte;
